import { logger } from '@luna/logger';
import { getEnv } from '@luna/env';
import { request } from '@luna/api';

interface ExchangeTokenResponse {
    access_token: string;
}

/**
 * @deprecated
 * This should not be used directly.
 * Please use `getHandoffUrl` function.
 */
export const ExchangeToken = {
    exchangedTokens: {},
    exchangeTokenIsLoading: {} as Record<string, boolean>,
    exchangeTokenCallbacks: {} as Record<string, any>,
    setIsLoading(status: boolean, clientId: string) {
        this.exchangeTokenIsLoading[clientId] = status;
    },
    invokeCallbacksWith(argument: string | null, clientId: string) {
        // @ts-expect-error no-implicit-any
        this.exchangeTokenCallbacks[clientId].forEach((callback) => {
            callback(argument);
        });
    },
    // @ts-expect-error no-implicit-any
    exchangeToken(clientId, callback?) {
        // @ts-expect-error no-implicit-any
        const exchangedToken = this.exchangedTokens[clientId];

        if (exchangedToken && callback) {
            callback(exchangedToken);
            return;
        }

        if (this.exchangeTokenIsLoading[clientId] && callback) {
            this.exchangeTokenCallbacks[clientId].push(callback);
            return;
        }

        this.exchangeTokenCallbacks[clientId] = [];
        this.setIsLoading(true, clientId);

        request<ExchangeTokenResponse>(
            `${getEnv().stsUrl}exchange?targetClientId=${clientId}`,
        ).then(
            (data) => {
                if (!data?.access_token) {
                    logger.error('TokenExchange :: No token received from service');
                    return;
                }

                // @ts-expect-error no-implicit-any
                this.exchangedTokens[clientId] = data.access_token;
                if (callback) {
                    callback(data.access_token);
                }
                this.setIsLoading(false, clientId);
                this.invokeCallbacksWith(data.access_token, clientId);
            },
            (err) => {
                this.setIsLoading(false, clientId);
                logger.error('TokenExchange :: Exchange failed', err);
                if (callback) {
                    callback(null);
                }
                this.invokeCallbacksWith(null, clientId);
            },
        );
    },
};
